import { useGroupUserRoles, useOrganizationInfo, useUserId } from '@features/user';
import { FeatureGates, useFeatureGate } from '@services/statsig';
import { hasAnyRole, ROLES } from '@utils/roleUtils';

const ORG_SCHEDULE_ROLES = [
  ROLES.PRACTICE_ADMINISTRATOR,
  ROLES.BILLING_ADMINISTRATOR,
  ROLES.OPERATIONS_SUPPORT,
];

/**
 * Pure access-control hook for org-level schedule features.
 *
 * Checks the Statsig feature gate, user's org roles, AND whether
 * the organization is a group (more than one member).
 * Does NOT fetch any data — data concerns (e.g. org members)
 * belong in the filter hook or filter bar component.
 */
export function useOrgScheduleAccess() {
  const isFeatureGateEnabled = useFeatureGate(FeatureGates.ORG_SCHEDULE);
  const groupUserRoles = useGroupUserRoles();
  const currentUserId = useUserId();
  const orgInfo = useOrganizationInfo();

  const isGroupOrg = orgInfo?.group ?? false;
  const hasOrgScheduleRole = hasAnyRole(groupUserRoles, ORG_SCHEDULE_ROLES);
  const hasOrgScheduleAccess = isFeatureGateEnabled && hasOrgScheduleRole && isGroupOrg;

  return {
    hasOrgScheduleAccess,
    isFeatureGateEnabled,
    hasOrgScheduleRole,
    isGroupOrg,
    currentUserId,
  };
}
